/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { BOOKING_BATCH_TYPES } from "../../constants/constants";

export const formatBookingResponse = ({ response, isInvoice = false }) => {
  const bookingsList = isInvoice
    ? response.lines
        ?.filter((line) => line.type === "booking" || line.type === "deposit")
        .flatMap((line) => {
          return line.bookings.map((booking) => {
            const relatedProducts = response.lines
              .filter((pLine) => pLine.type === "product")
              .filter((pLine) => booking.id === pLine.booking_id);

            return {
              ...booking,
              products: relatedProducts,
            };
          });
        })
    : response;

  const batchValue = isInvoice
    ? response.lines
        ?.filter((line) => line.type === "booking" || line.type === "deposit")
        .flatMap((line) => line.bookings ?? [])?.[0]?.batch_type ?? null
    : response[0]?.batch_type;

  if (batchValue === BOOKING_BATCH_TYPES.RECURRING) {
    const [firstBooking, ...recurringSessions] = bookingsList;

    return [{ ...firstBooking, recurring_sessions: recurringSessions }];
  }

  if (batchValue === BOOKING_BATCH_TYPES.MULTIPLE) {
    return bookingsList;
  }

  if (batchValue === BOOKING_BATCH_TYPES.GROUP) {
    const [firstBooking] = bookingsList;
    const products = bookingsList.flatMap((booking) => booking.products ?? []);

    // This is due to the fact that group booking is a single booking with multiple services
    // So we need to return a single booking with the group booking count
    return [
      {
        ...firstBooking,
        products,
        service: {
          ...firstBooking.service,
          group_booking_count: bookingsList.length,
        },
      },
    ];
  }

  return bookingsList;
};
